
import Vue from 'vue'
import ProjectMixin from '@/_mixins/project'

import FormResponseViewerDialog from '@/views/Project/PSI/dialogs/formResponseViewer.vue'
import FormResponseDialog from '@/views/Project/PSI/dialogs/formResponse.vue'

const PsiCard = Vue.extend({
    mixins: [ProjectMixin],
    props: {
        psiItem: {
            type: Object,
        },
        activeRevisions: {
            type: Array,
        },
    },
    data() {
        return {
            psi: this.psiItem,
        }
    },
    watch: {
        psiItem: {
            handler() {
                this.psi = this.psiItem
            },
        },
    },
    computed: {
        activeRevision() {
            return this.activeRevisions[0] ? this.activeRevisions[0] : null
        },
        openCompletions() {
            let filtered = this.psi.myCompletions.data.filter(
                (item) => item.status == 'open' && item.version == this.activeRevision.version
            )
            let sorted = filtered.sort((a, b) => {
                if (a.time && b.time) {
                    return new Date(b.time).getTime() - new Date(a.time).getTime()
                }
                return 0
            })
            return sorted
        },
        latestOpenCompletion() {
            return this.openCompletions[0]
        },

        submittedCompletions() {
            let filtered = this.psi.myCompletions.data.filter((item) => item.status == 'done')
            let sorted = filtered.sort((a, b) => {
                if (a.time && b.time) {
                    return new Date(b.time).getTime() - new Date(a.time).getTime()
                }
                return 0
            })
            return sorted
        },

        latestSubmitedCompletion() {
            return this.submittedCompletions[0]
        },
        hasSubmittedCompletions() {
            return !!this.latestSubmitedCompletion
        },
        title() {
            let title = this.activeRevision.data.title[this.activeRevision.data.languages[0]]

            // Show title in the user language is available
            if (this.activeRevision.data.title[this.userLanguage]) {
                title = this.activeRevision.data.title[this.userLanguage]
            }
            // if above not available, show title in the language of user last completed response
            // else if (this.activeRevision.data.title[this.latestSubmitedCompletion.]) {

            // }
            return title
        },
    },
    methods: {
        async createResponse(revision: any = {}) {
            let languages = this.activeRevision.data.languages
            let language = languages.includes(this.userLanguage) ? this.userLanguage : languages[0]

            await this.openDialog(FormResponseDialog, {
                revision,
                language,
                languages,
                psi: this.psi,
                isPreview: false,
                latestSubmitedCompletion: this.latestSubmitedCompletion,
                ...(this.latestOpenCompletion && { psiCompletion: this.latestOpenCompletion }),
            })

            setTimeout(() => {
                this.$emit('reload', this.psi)
            }, 500)
        },

        async viewSubmission() {
            this.openDialog(FormResponseViewerDialog, {
                resourceFormResponse: this.latestSubmitedCompletion,
                psi: this.psi,
            })
        },
    },
})

export default PsiCard
